export enum PermissionModule {
    GestaoUsuarios = 1,
    InstituicoesCursos = 2,
    Agenda = 3,
    Terceiros = 4,
    Contratos = 5,
    PreparacaoAlbuns = 6,
    Vendas = 7,
    RelatorioVendas = 8,
    AlunoDetalhado = 9,
    Financeiro = 10,
    Produtos = 11,
    Despesas = 12,
    Custos = 13,
    RelatorioContratos = 14,
}

export const MODULE_LABELS: Record<PermissionModule, string> = {
    [PermissionModule.GestaoUsuarios]: "Gestão de Usuários",
    [PermissionModule.InstituicoesCursos]: "Instituições e Cursos",
    [PermissionModule.Agenda]: "Agenda",
    [PermissionModule.Terceiros]: "Terceiros",
    [PermissionModule.Contratos]: "Contratos",
    [PermissionModule.PreparacaoAlbuns]: "Preparação de Álbuns",
    [PermissionModule.Vendas]: "Vendas",
    [PermissionModule.RelatorioVendas]: "Relatório de Vendas",
    [PermissionModule.AlunoDetalhado]: "Aluno Detalhado",
    [PermissionModule.Financeiro]: "Financeiro",
    [PermissionModule.Produtos]: "Produtos",
    [PermissionModule.Despesas]: "Despesas",
    [PermissionModule.Custos]: "Custos",
    [PermissionModule.RelatorioContratos]: "Relatório de Contratos",
};

export interface ModulePermissionType {
    module: PermissionModule;
    permissions: number[];
}

export interface UserPermissionsResponse {
    useLegacyPermissions: boolean;
    legacyPermissions: number[];
    modulePermissions: ModulePermissionType[];
}

export function createPermissionChecker(
    useLegacyPermissions: boolean,
    legacyPermissions: number[],
    modulePermissions: ModulePermissionType[]
): (module: PermissionModule | null, action: number) => boolean {
    return function hasPermission(module: PermissionModule | null, action: number): boolean {
        const hasModular = module !== null
            ? (modulePermissions.find(mp => mp.module === module)?.permissions.includes(action) ?? false)
            : false;

        if (useLegacyPermissions) {
            return hasModular || legacyPermissions.includes(action);
        }
        return hasModular;
    };
}
